// extracted by mini-css-extract-plugin
export default {"title":"Article_title_QMiO3","date":"Article_date_Kdfx_","content":"Article_content_QSeg6"};